<div class="modal-header">
  <h5 class="modal-title">
    Histórico de alteração
    <small class="d-block history-subtitle">{{ configuration.label }} — <code>{{ configuration.key }}</code></small>
  </h5>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar"
    (click)="activeModal.dismiss()" data-testid="btn-close-history">
    <i class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <div *ngIf="isLoading" data-testid="history-loading">
    <app-skeleton variant="table-row" [count]="4" [columns]="4" label="Carregando o histórico"></app-skeleton>
  </div>

  <!-- A leitura do histórico está subindo em paralelo: enquanto a rota não
       existe, o painel avisa e o resto da tela segue funcionando. -->
  <div class="alert history-notice" *ngIf="!isLoading && isUnavailable" data-testid="history-unavailable">
    <i class="fa fa-info-circle"></i>
    <span>O histórico desta configuração ainda não está disponível neste ambiente. As alterações continuam sendo
    registradas — a consulta é que ainda não foi publicada.</span>
  </div>

  <div class="alert alert-danger history-notice" *ngIf="!isLoading && loadError" data-testid="history-error">
    <i class="fa fa-exclamation-triangle"></i>
    <span>{{ loadError }}</span>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="load(requestedPage)" data-testid="btn-retry-history">
      Tentar de novo
    </button>
  </div>

  <div class="text-center py-3 history-empty" *ngIf="isEmpty" data-testid="history-empty">
    Nenhuma alteração registrada para esta chave.
  </div>

  <div *ngIf="!isLoading && !isUnavailable && !loadError && entries.length > 0">
    <div class="table-responsive">
      <table class="table table-sm mb-0" data-testid="history-table">
        <thead>
          <tr>
            <th>Quando</th>
            <th>Quem</th>
            <th>De</th>
            <th>Para</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of entries; trackBy: trackByAuditId" data-testid="history-row">
            <td class="history-when">
              {{ entry.created_at | date : 'dd/MM/yyyy, HH:mm:ss' }}
            </td>
            <td class="history-who">
              <ng-container *ngIf="entry.user_email; else systemActor">{{ entry.user_email }}</ng-container>
              <ng-template #systemActor><i>Sistema</i></ng-template>
              <small class="history-subtitle d-block" *ngIf="entry.ip">
                <i class="fa fa-globe me-1"></i>{{ entry.ip }}
              </small>
            </td>
            <td class="history-old" data-testid="history-old">
              <span *ngIf="hasMoney(entry.old_value)">{{ asMicros(entry.old_value) | moneyMicros }}</span>
              <span *ngIf="hasDatetime(entry.old_value)">{{ entry.old_value | date : 'dd/MM/yyyy, HH:mm' }}</span>
              <span *ngIf="!hasMoney(entry.old_value) && !hasDatetime(entry.old_value)">
                {{ describe(entry.old_value) }}
              </span>
            </td>
            <td class="history-new" data-testid="history-new">
              <span *ngIf="hasMoney(entry.new_value)">{{ asMicros(entry.new_value) | moneyMicros }}</span>
              <span *ngIf="hasDatetime(entry.new_value)">{{ entry.new_value | date : 'dd/MM/yyyy, HH:mm' }}</span>
              <span *ngIf="!hasMoney(entry.new_value) && !hasDatetime(entry.new_value)">
                {{ describe(entry.new_value) }}
              </span>
              <!-- Chave de cobrança gravada pelo passo de confirmação (CU-86akkmfhx). -->
              <span class="history-confirmed d-block" *ngIf="entry.confirmed === true" data-testid="history-confirmed">
                <i class="fa fa-check-circle me-1"></i>confirmado
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-pagination *ngIf="totalItems > perPage" [currentPage]="currentPage" [itemsPerPage]="perPage"
      [totalItems]="totalItems" (pageChanged)="load($event)"></app-pagination>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="sf-btn sf-btn--secondary" (click)="activeModal.dismiss()">Fechar</button>
</div>
